import React, { useState } from 'react';
import BaseTableNew from 'components/atoms/base-table/new';
import BaseModal from 'components/atoms/base-modal';
import BaseInputNumber from 'components/atoms/base-input-number';
import { useTranslation } from 'react-i18next';
import BaseButton from 'components/atoms/baseButton';
import {
  useGetQueueLimits,
  useUpdateQueueLimit,
} from 'infrastructure/hooks/adherence-settings';

import { columns } from './columns';

import type { IAdherenceSettingQueueLimit } from 'infrastructure/interfaces';

const AdherenceSettingsQueueLimitTable: React.FC = () => {
  const { t } = useTranslation();
  const { data, isLoading } = useGetQueueLimits();
  const { mutateAsync, isLoading: updateLoading } = useUpdateQueueLimit();

  const loading = isLoading || updateLoading;

  const [selected, setSelected] = useState<
    IAdherenceSettingQueueLimit | undefined
  >(undefined);
  const [selectedLimit, setSelectedLimit] = useState(0);

  const onEdit = (rec: IAdherenceSettingQueueLimit) => {
    setSelected(rec);
    setSelectedLimit(rec.limit);
  };

  const onCancel = () => {
    setSelected(undefined);
  };

  const handleSave = async () => {
    const val = Number.isInteger(selectedLimit) ? selectedLimit : 0;
    if (selected) {
      await mutateAsync({
        guid: selected?.guid,
        limit: val,
      });
      setSelected(undefined);
    }
  };

  return (
    <>
      <BaseTableNew
        dataCy="adherence-settings-queue-limit-table"
        rowKey="guid"
        columns={columns({ onEdit })}
        items={data}
        loading={isLoading}
        pagination={{
          current: 1,
          pageSize: 20,
          total: data.length,
        }}
        bordered
      />
      <BaseModal
        open={!!selected}
        title={t('labels.edit')}
        onCancel={onCancel}
        loading={updateLoading}
        withFooter={[
          <BaseButton
            dataCy="form-save-button"
            label={t('controls.save')}
            onClick={handleSave}
            loading={updateLoading}
            disabled={loading}
          />,
          <BaseButton
            type="secondary"
            dataCy="form-cancel-button"
            label={t('controls.cancel')}
            onClick={onCancel}
            loading={updateLoading}
            disabled={loading}
          />,
        ]}
      >
        <BaseInputNumber
          disabled={updateLoading}
          min={0}
          value={selectedLimit}
          onChange={setSelectedLimit}
          max={10000}
          formatter={(value: any) => `${Math.floor(Number(value))}`}
        />
      </BaseModal>
    </>
  );
};

export default AdherenceSettingsQueueLimitTable;
